import React, { useCallback, useEffect, useState } from 'react'
import { useSiteMetadata } from '../hooks/use-site-metadata'
import MobileNavBar from './nav/mobile-nav'
import DesktopNavBar from './nav/desktop-nav'
import * as styles from '../styles/components/nav-bar.module.scss'
import useResize from '../hooks/use-resize'
import Ribbon from './ribbon'
import { useGlobalRibbonData } from '../hooks/use-ribbon-data'
import cx from 'classnames'

interface State {
    scrollPosition: number
    mobileNavExpanded: boolean
    mobileNavWasToggled?: boolean
}

const NavBar = () => {
    const { navLinks: navLinksRaw, title } = useSiteMetadata()
    const ribbonData = useGlobalRibbonData()
    const navLinks = navLinksRaw?.map((link) => link) ?? []
    const [state, setState] = useState<State>({ scrollPosition: 0, mobileNavExpanded: false })

    const mobileNavToggleHandler = () => {
        setState({ ...state, mobileNavExpanded: !state.mobileNavExpanded, mobileNavWasToggled: true })
    }

    useEffect(() => {
        const handleScroll = () => {
            const position = window.scrollY
            setState((s) => ({ ...s, scrollPosition: position }))
        }

        window.addEventListener('scroll', handleScroll, { passive: true })

        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    // Hide menu dropdown if e.g. mobile device is rotated to landscape mode
    const handleResize = useCallback(() =>
        setState((s) => ({
            ...s, mobileNavExpanded: false, mobileNavWasToggled: false,
        })), [])

    useResize(handleResize)

    return (
        <div className={cx(styles.container, { [styles.containerTop]: state.scrollPosition <= 0 })}>
            {ribbonData && <Ribbon data={ribbonData} />}
            <MobileNavBar
                links={navLinks}
                mobileNavExpanded={state.mobileNavExpanded}
                mobileNavWasToggled={!!state.mobileNavWasToggled}
                navToggleHandler={mobileNavToggleHandler}
                className={styles.mobileNavBar}
            />
            <DesktopNavBar
                links={navLinks}
                title={title}
                scrolledToTop={state.scrollPosition <= 0}
                className={styles.desktopNavBar}
            />
        </div>
    )
}

export default NavBar
